export default __webpack_public_path__ + "static/media/176.cda76f1b.gif";